import type {AlertProps} from '@chakra-ui/react';
import {Alert as ChakraAlert, forwardRef} from '@chakra-ui/react';

import {AlertProvider, useStyles} from './context';
import {parts} from './theme/anatomy';
import {alertTheme} from './theme/theme';

export const Alert = forwardRef<AlertProps, 'div'>((props, ref) => {
  const {size, status, sx} = props;
  const {container} = useStyles();
  return (
    <AlertProvider value={{size, status}}>
      <ChakraAlert
        styleConfig={alertTheme}
        {...props}
        sx={{...sx, ...container}}
        {...{'data-variant': props.variant}}
        {...parts.container.attrs}
        ref={ref}
      />
    </AlertProvider>
  );
});

Alert.displayName = `Alert`;
export type {AlertProps};
